import type { InputPuzzle } from "./puzzle.types";

export const GRANDMASTER_PUZZLES: InputPuzzle[] = [
  {
    p: "103000007004935001095000000000054000400061020500700040001280500200000079000003000",
    s: "123648957764935281895172634372854196489361725516729348941287563238516479657493812",
    d: 58000000,
  },
  {
    p: "003790000068000500000030002005000970000000140000980000900501000000006000001070006",
    s: "123795864768412539459638712285164973697253148314987625936521487572846391841379256",
    d: 58000000,
  },
  {
    p: "100000905760000140000000000200970500000600000007003208005034000043205800000700000",
    s: "124867935768359142359421786236978514581642397497513268875134629643295871912786453",
    d: 58000000,
  },
  {
    p: "024069700700005908000004000090030200000000000005000806401000000080600002006000005",
    s: "124869753763125948958374621897536214642981537315742896471258369589613472236497185",
    d: 58000000,
  },
  {
    p: "100060080000750000000000010010027000003090000700300004000004095450800700002000003",
    s: "124963587968751432537248916816427359243195678795386124381674295459832761672519843",
    d: 58000000,
  },
  {
    p: "005000089798000304000000002600520000000390060304008000000700000000002000031000045",
    s: "125473689798261354463859172619527438872394561354618927986745213547132896231986745",
    d: 58000000,
  },
  {
    p: "026000000004000100080001290500067010400800000070059000000000002830005007000600300",
    s: "126983745954726138783541296592467813461832579378159624615374982839215467247698351",
    d: 58000000,
  },
  {
    p: "000490060006000058050007004000000531590080006200000400000003000040000002002100000",
    s: "128495763476231958359867124684972531591384276237516489915623847843759612762148395",
    d: 58000000,
  },
  {
    p: "120000406400809001090040000802005600050000010000708000014920005000000002003000000",
    s: "128573496475869231396241758832415679957632814641798523714926385569387142283154967",
    d: 58000000,
  },
  {
    p: "020007000070013002004000009086050000000000610900002000010020040067405000003000008",
    s: "128947365679513482534268179386751294752894613941632857815329746267485931493176528",
    d: 58000000,
  },
  {
    p: "009370008050009002700000400008001000410090007000020140060000000590083000000000306",
    s: "129374568354869712786152493978431625412596837635728149863247951591683274247915386",
    d: 58000000,
  },
  {
    p: "009060050080000400360709000900010200000000000010000063040500780600800010000072000",
    s: "129468357587321496364759128938617245456283971712945863241536789673894512895172634",
    d: 58000000,
  },
  {
    p: "030400000000200015000009007400000006000001000600050090509060072000000000008710400",
    s: "132475968794286315856139247471923586985641723623857194519364872247598631368712459",
    d: 58000000,
  },
  {
    p: "100000006500027040000650000020004039000910052000000000070069025009000000080000010",
    s: "132498576596327148847651293721584639468913752953276481374169825219845367685732914",
    d: 58000000,
  },
  {
    p: "130007000709030040004002000900700005006000004010000890005000008000000709003408000",
    s: "132547986769831542854692317948713265326985174517264893675129438481356729293478651",
    d: 58000000,
  },
  {
    p: "030079400000000090708004000000950060000000107006020000200600000073001200040000000",
    s: "132579486564218793798364521417953862329486157856127934281645379673891245945732618",
    d: 58000000,
  },
  {
    p: "002809000450100008000000040670000200000000060800000490009206007006400000210000000",
    s: "132849576457162938968753142671394285394528761825671493549236817786415329213987654",
    d: 58000000,
  },
  {
    p: "104009060000000034000046102610900000020800700003000001280100006000000205300000000",
    s: "134529867562718934978346152617932548425861793893475621289154376741693285356287419",
    d: 58000000,
  },
  {
    p: "030050807000300001000401030700003600010600004000109005009000000800500000000000179",
    s: "136952847482367951957481236795843612218675394643129785329714568871596423564238179",
    d: 58000000,
  },
  {
    p: "000056400900800002002090070400000200000704008069000005803070010570000800000000000",
    s: "137256489954817632682493571418935267325764198769128345843572916571649823296381754",
    d: 58000000,
  },
  {
    p: "000025000408100030000040800915000726080000009076000000050000002001003008000200010",
    s: "137825694468197235592346871915438726384672159276951483859714362721563948643289517",
    d: 58000000,
  },
  {
    p: "000005060500600100020000003003500980000030600400280000080000000001070290000040057",
    s: "138725469547693128629418573273564981895137642416289735784952316351876294962341857",
    d: 58000000,
  },
  {
    p: "100060000000070003025000100007000030802030000004709860090300000000500000040006082",
    s: "139264578486175923725893146967458231852631497314729865291387654678542319543916782",
    d: 58000000,
  },
  {
    p: "109608400006900000080407000003000100001000034800000020000780002010000000904000600",
    s: "139628475746953281582417369423865197651279834897341526365784912218596743974132658",
    d: 58000000,
  },
  {
    p: "000000060480000009000093501000000030540000700260009800806050000000280000001907000",
    s: "139875462485612379672493581918764235543128796267539814826351947794286153351947628",
    d: 58000000,
  },
  {
    p: "000000007070030600000200000452009000001000400000600300504000028000090000008060050",
    s: "143956287275831649896247531452319876631785492789624315564173928327598164918462753",
    d: 58000000,
  },
  {
    p: "005000207260000080390500000006000090000690700000040000009008002050001000001000465",
    s: "145986237267314589398572146736125894584693721912847653679458312453261978821739465",
    d: 58000000,
  },
  {
    p: "000090000087300090500400600650000008001000005000840000060030084020000107010000020",
    s: "146792853287356491593418672654179238871623945932845716769231584325984167418567329",
    d: 58000000,
  },
  {
    p: "000000060920801000000400208000000003010000507307008000000003100400096000075000002",
    s: "148325769926871354753469218562917483814632597397548621289753146431296875675184932",
    d: 58000000,
  },
  {
    p: "009005000000600010530000004000002500061009020008000030080100600094000000700040000",
    s: "149275386827634915536918274973482561461359728258761439385197642694823157712546893",
    d: 58000000,
  },
  {
    p: "000000000080120009206009040000000006001000700400507890010003080000070402030000600",
    s: "149356278387124569256789143978412356561938724423567891712643985695871432834295617",
    d: 58000000,
  },
  {
    p: "000072050000500109005010080080000070530060012002740800000000000096250000010000000",
    s: "149872653678534129325619784481325976537968412962741835754193268896257341213486597",
    d: 58000000,
  },
  {
    p: "052000300000801500000000070400230090003940000000000730960070000080000657020500000",
    s: "152764389637891542849352176416237895573948261298615734965173428381429657724586913",
    d: 58000000,
  },
  {
    p: "000004700300670009000010028000020000090000300720060000000005600030800004910000070",
    s: "152984736348672159679513428865321947491758362723469581287145693536897214914236875",
    d: 58000000,
  },
  {
    p: "003004900076002000000030040000000030047000000000010008800009000020800100610050002",
    s: "153684927476592381298731645981475236347268519562913478835129764729846153614357892",
    d: 58000000,
  },
  {
    p: "053000040000003879800000000934002000200069000080000000000010030020006091700000020",
    s: "153897246462153879879624315934582167215769483687341952596218734328476591741935628",
    d: 58000000,
  },
  {
    p: "006007090000520703000900000503000000004032000091000008400800205000000340060000007",
    s: "156347892948526713732981654573498126684132579291765438419873265827659341365214987",
    d: 58000000,
  },
  {
    p: "000009200000000090740010000260197000415000008007000000680200000000046030000900040",
    s: "156379284823564197749812365268197453415623978937458621684235719591746832372981546",
    d: 58000000,
  },
  {
    p: "000029403080001070007600000003000900070006001200340000020080000800000000905000007",
    s: "156729483382451679497638215643817952578296341219345768724583196861972534935164827",
    d: 58000000,
  },
  {
    p: "007600000000030025000007019000050000700000400004800030480003000000025080093000002",
    s: "157692843946138725328547619819354267735261498264879531482713956671925384593486172",
    d: 58000000,
  },
  {
    p: "000340607000070000002000143601000005509280000003400900000035000800600000000800706",
    s: "158342697436179258972568143621793485549286371783451962267935814814627539395814726",
    d: 58000000,
  },
  {
    p: "009000004000050300840006900790503000005000098600000000306200000002035000080007600",
    s: "159382764267459381843176925798523416435761298621894573376248159912635847584917632",
    d: 58000000,
  },
  {
    p: "000820000000094508030000290070200100000408300501000000900000400085900000002000006",
    s: "159823647627194538834576291378259164296418375541637829963781452485962713712345986",
    d: 58000000,
  },
  {
    p: "000000000700006400920500001001090804300201000000008000000300000200004080403060290",
    s: "165432978738916452924587631571693824389241765642758319857329146296174583413865297",
    d: 58000000,
  },
  {
    p: "005000003007014000040002005006000429000070500000800000000000107090060000054003002",
    s: "165987243327514986948632715876351429419276538532849671683425197291768354754193862",
    d: 58000000,
  },
  {
    p: "000024000020096001000080670700000005090030000500000840800003000000900080000018206",
    s: "167524398328796451459381672783142965694835127512679843846253719231967584975418236",
    d: 58000000,
  },
  {
    p: "067000500000001000200400001070603000000000390005700064000047000008500009500900200",
    s: "167839542854271936293465781479683125682154397315792864921347658738526419546918273",
    d: 58000000,
  },
  {
    p: "000400500200007080370000026000050309010700008090002600900003005000000001400080000",
    s: "168429573259367184374815926742658319613794258895132647981273465527946831436581792",
    d: 58000000,
  },
  {
    p: "100008004000009001060000080050200060014000300700000509000530000487001005000000070",
    s: "172358694348769251965142783859213467614975328723486519291537846487621935536894172",
    d: 58000000,
  },
  {
    p: "000040090080001060002000005007002000000084030605000809050010000000000007000203000",
    s: "173645298589721463462398175837962541291584736645137829756419382324856917918273654",
    d: 58000000,
  },
  {
    p: "100500023003400000090000060050000100008017000009200000001020000000340070060000490",
    s: "174568923683492715592173864256934187438617259719285346941726538825349671367851492",
    d: 58000000,
  },
  {
    p: "100500009000000806500002000840000010020060000009027000010000090000003000080004030",
    s: "174586329932741856568932147847359612321468975659127483413675298295813764786294531",
    d: 58000000,
  },
  {
    p: "170096002000087050008000007000000090040050028006000400620000100009000003000073000",
    s: "175496382932187654468532917287314596341659728596728431623845179759261843814973265",
    d: 58000000,
  },
  {
    p: "070830000000200700005000609050080000001006000800000403067000018000000000200910050",
    s: "176839542489265731325174689654382197731496825892751463967543218513628974248917356",
    d: 58000000,
  },
  {
    p: "000000000046000701209100600300000070080030050490700080000082003000910020010050000",
    s: "178346295546829731239175648321598476687234159495761382754682913863917524912453867",
    d: 58000000,
  },
  {
    p: "082500900000006000006000381300000600700413009020000000000040007000700810000009000",
    s: "182537946439186752576294381341952678768413529925678134653841297294765813817329465",
    d: 58000000,
  },
  {
    p: "080704003600000900900008002070005000000300005010060000700000000004020097050080001",
    s: "182794653637251984945638172379815246426379815518462739791546328864123597253987461",
    d: 58000000,
  },
  {
    p: "080000200000010306000000000038090000025038000600070500301009400090000037000400002",
    s: "183946275542817396976352841738695124425138769619274583361729458294581637857463912",
    d: 58000000,
  },
  {
    p: "000000006240090000500810700010003070008005300002680000000000000000004050800060014",
    s: "189437526247596183536812749615943872498275361372681495924158637761324958853769214",
    d: 58000000,
  },
  {
    p: "002600000000004000080100000040800000000050039803097100070320004000000985010009000",
    s: "192635478735984261486172593941863752267451839853297146579328614324716985618549327",
    d: 58000000,
  },
  {
    p: "000650000004070003080002090000100250520000000006030400030900746800000000060000001",
    s: "192653874654879123783412695348196257521748369976235418235981746817564932469327581",
    d: 58000000,
  },
  {
    p: "100008035000050070004900000089230000000000004403700900307160000600000000000000200",
    s: "192678435836452179754913826589234617271596384463781952327169548648325791915847263",
    d: 58000000,
  },
  {
    p: "190008000000010000000000706009007050004002008608040000020300007007005000500009803",
    s: "192768435763514289485293716219837654374652198658941372921386547837425961546179823",
    d: 58000000,
  },
  {
    p: "000000360540200000070000900018006000700030000000502000000009604000005000001460070",
    s: "192847365546293781873651942418976523725134896639582417287319654964725138351468279",
    d: 58000000,
  },
  {
    p: "000020000800000031070013020030000010009800002004060500000296000068450000000000050",
    s: "193528467825674931476913825532749618619835742784162593357296184268451379941387256",
    d: 58000000,
  },
  {
    p: "000750080000000100005090020904000008300007051000020060709204000208300000006008000",
    s: "193752684627483195845196327964531278382647951571829463759214836218365749436978512",
    d: 58000000,
  },
  {
    p: "090000002340200050000170090700403800006700000000000020470006000502000009610000004",
    s: "195634782347289156268175493721493865836752941954861327479516238582347619613928574",
    d: 58000000,
  },
  {
    p: "000000000000070160600092850009000006030004000804900007500801093340700000001000020",
    s: "195648372482573169673192854219387546736254981854916237527861493348729615961435728",
    d: 58000000,
  },
  {
    p: "100006000000900003062040010480000000200050000000708040036402700520000069000007000",
    s: "198376524754921683362845917485219376273654198619738245836492751527183469941567832",
    d: 58000000,
  },
  {
    p: "000040000000192300000603120300409080400200000027000030900300000008005000001080005",
    s: "213548976876192354594673128365419782489237561127856439952361847748925613631784295",
    d: 58000000,
  },
  {
    p: "004005600800000700000040050703000008000009000001006000020900301006500000008003029",
    s: "214795683859632714637148952763254198582319476941876235425987361396521847178463529",
    d: 58000000,
  },
  {
    p: "200000060006059001000000050000200400090000000100490007300000004000070080400802509",
    s: "215748963876359241943621758638217495794583612152496837387965124529174386461832579",
    d: 58000000,
  },
  {
    p: "000503000300000080800400103724300006060000500000040000000000200450706000087050000",
    s: "216583479349127685875469123724315896163978542598642731631894257452736918987251364",
    d: 58000000,
  },
  {
    p: "010000000000807000040061050800000009650000400000002100000090000023006700000004083",
    s: "217539846569847321348261957872413569651978432934652178786395214423186795195724683",
    d: 58000000,
  },
  {
    p: "019003080036000005040000700800200306000006400001000002000900070075010000000040000",
    s: "219573684736498125548621739897254316352186497461739852184965273675312948923847561",
    d: 58000000,
  },
  {
    p: "009580000000000002057009000040000008035090001072350000000000060000705020003140000",
    s: "219583647386417952457629813941276538635894271872351496724938165198765324563142789",
    d: 58000000,
  },
  {
    p: "010000000460109000007400200000900002000216004008000000500070080030000700900000010",
    s: "219738546465129378387465291654987132793216854128543967542371689831694725976852413",
    d: 58000000,
  },
  {
    p: "200800010890500002000091000000300850403100006050080007067000000502000600000000300",
    s: "235867914891534762674291583726349851483175296159682437367458129542913678918726345",
    d: 58000000,
  },
  {
    p: "030580000000026005000000700006037000300000400098100000001050360600400000902000070",
    s: "237589146184726935569314782416237859325698417798145623871952364653471298942863571",
    d: 58000000,
  },
  {
    p: "000500000000200003058001900860020700000015090003800100000000000000603001072004500",
    s: "239546817617298453458731926861429735724315698593867142186952374945673281372184569",
    d: 58000000,
  },
  {
    p: "009004100700000000000010030005000900000003008042009060007006040400005096080700000",
    s: "239654187714238659568917234875461923691523478342879561157396842423185796986742315",
    d: 58000000,
  },
  {
    p: "000300500090000102805020340060070004903408000000000093010760000007102000000005000",
    s: "241397586396584172875621349168973254923458617754216893512769438487132965639845721",
    d: 58000000,
  },
  {
    p: "040600000900000001000002350569000800400000006003000700000004000000960007172008000",
    s: "241635978935847621786192354569713842427589136813426795698274513354961287172358469",
    d: 58000000,
  },
  {
    p: "040070069001000030570800000000000010900041080000090503004000050850036000000002300",
    s: "243175869681924735579863421438257916965341287712698543324719658857436192196582374",
    d: 58000000,
  },
  {
    p: "003590071008000030000000000054003006010000090002409010000070020090064000300000000",
    s: "243596871568147932179832564954713286817625493632489715485371629791264358326958147",
    d: 58000000,
  },
  {
    p: "040800000108063007000021300020090003014005600900030050000000076001000020400700000",
    s: "243857961158963247679421385527698413314275698986134752832549176791386524465712839",
    d: 58000000,
  },
  {
    p: "000001680000052030105040000000000060004000000832005000907100803000008000050000019",
    s: "243971685796852431185643972519287364674319528832465197967124853321598746458736219",
    d: 58000000,
  },
  {
    p: "040003700000000060050002009500000930700005020680400070320150400000000600000004013",
    s: "246593781973841562158762349514287936739615824682439175327156498491328657865974213",
    d: 58000000,
  },
  {
    p: "000060800000000005500800000020000001071350000006900040090005030008602400002007006",
    s: "247569813183274695569813274925748361471356928836921547694185732718632459352497186",
    d: 58000000,
  },
  {
    p: "000608000910000000005000020400503270000800149000007000004300006020000000651070000",
    s: "247638951916254783835791624469513278573826149182947365794382516328165497651479832",
    d: 58000000,
  },
  {
    p: "000068050309500040060400007000050273000000100010209800020830006000010000004000000",
    s: "247968351389571642561423987498156273652387194713249865925834716836715429174692538",
    d: 58000000,
  },
  {
    p: "200000063071080000000000080600340000002600800003102004000007090000005040090000001",
    s: "248791563371586429569234187657348912412679835983152674825417396136925748794863251",
    d: 58000000,
  },
  {
    p: "000300600001400500087002000003000905020000860005200000002078003100500200700000000",
    s: "249357618361489572587162349673814925924735861815296734452678193196543287738921456",
    d: 58000000,
  },
  {
    p: "209000700700008060060004001905002000000000000007046002890003500000000108010400070",
    s: "249651783751328469368794251935812647624937815187546932896173524473265198512489376",
    d: 58000000,
  },
  {
    p: "000003400080060005090000003030059000000004060000001007007090004900015000510200008",
    s: "251973486483162975796548123632759841175384269849621357327896514968415732514237698",
    d: 58000000,
  },
  {
    p: "050000089000000001000030000030700090400008600000010750008900500600800000104002000",
    s: "253167489749285361861439275536724198417598623982316754328971546675843912194652837",
    d: 58000000,
  },
  {
    p: "050090700400023006080510000000046000000000000608009400700030040002000507000000108",
    s: "253694781471823956986517324529146873147385269638279415715938642892461537364752198",
    d: 58000000,
  },
  {
    p: "000904010083001002000000900700003005000170009005000600008300000002050043000000500",
    s: "256934817983761452471528936729643185864175329315289674548397261192856743637412598",
    d: 58000000,
  },
  {
    p: "207000000004000920000073000000008010700690500005000400010004060000030100002000304",
    s: "257489631834165927961273845629548713743691582185327496318754269476932158592816374",
    d: 58000000,
  },
  {
    p: "200016900000200780000000000036507000070600050040003007105000000090080000004700001",
    s: "257816934419235786368974512836527149971648253542193867125369478793481625684752391",
    d: 58000000,
  },
  {
    p: "200040306010900020003000800000200050084001000000070603000004000040000280500060000",
    s: "258147396416983725793526841167239458384651972925478613832714569641395287579862134",
    d: 58000000,
  },
  {
    p: "000409107000000000630500000000007001740050860000002090384000000092000680000000000",
    s: "258469137417328956639571428925687341741953862863142795384216579192735684576894213",
    d: 58000000,
  },
  {
    p: "000600090001500207097020000006040005080031000000000000100000060800009000304002700",
    s: "258617493631594287497823516716248935582931674943756821129475368875369142364182759",
    d: 58000000,
  },
  {
    p: "003090000004000069508010000002060000007002038000005900000003007830006000000100040",
    s: "263597481174238569598614372982361754657942138341785926415823697839476215726159843",
    d: 58000000,
  },
  {
    p: "060007000001030602300000100007056200800000006520708300010003040700009000040010000",
    s: "265187439471935682389264157137456298894321576526798314612873945753649821948512763",
    d: 58000000,
  },
  {
    p: "060100090000002307400700600000003050004006000600250010000000009048007000030000040",
    s: "267138594195642387483795621812973456354816972679254813526481739948327165731569248",
    d: 58000000,
  },
  {
    p: "260040000000007450040000080700000023900800000000014090000503070001900000000060000",
    s: "268345719139287456547196382784659123915832647623714598496523871351978264872461935",
    d: 58000000,
  },
  {
    p: "009000040500070600300009010030800000008003090020010007000060000000095104090020070",
    s: "269531748581472639347689512936847251718253496425916387154768923872395164693124875",
    d: 58000000,
  },
  {
    p: "000040900950020007000000800100083000700009030009000020030000000010005206800600400",
    s: "271348965958126347643957812124583679785269134369714528536492781417835296892671453",
    d: 58000000,
  },
  {
    p: "071000090300010000000020005000400280002000050850000017130050009600074020000000600",
    s: "271546398345918762986723145719435286462187953853269417134652879698374521527891634",
    d: 58000000,
  },
  {
    p: "201800005000004007000000910040370200100600000580000100010000804000580000003009000",
    s: "271896435359124687468735912946371258132658749587942163715263894694587321823419576",
    d: 58000000,
  },
  {
    p: "070005608054070090000008000000600007900000300000001500040020700030800001005030000",
    s: "271945638854376192396218475512693847987452316463781529148529763739864251625137984",
    d: 58000000,
  },
  {
    p: "200060490000070002300001800407000005001000000000306080750200900000000000004005006",
    s: "275863491618479352349521867467982135831754629592316784756248913123697548984135276",
    d: 58000000,
  },
  {
    p: "270000000000160000004309000008001004060002001400000508007403680000000000000000302",
    s: "276584913389167425154329876738951264965842731412736598527413689643298157891675342",
    d: 58000000,
  },
  {
    p: "070500003003020000009004080108005000000006000000000501090000000000700100007803065",
    s: "276598413843621759519374286138945627752136894964287531691452378385769142427813965",
    d: 58000000,
  },
  {
    p: "000009001900000872108030400580300010060002000000005026000000000000500008837000000",
    s: "276849351943651872158237469582396714769412583314785926425968137691573248837124695",
    d: 58000000,
  },
  {
    p: "000410009009000700401790000080200100752000000000030050800000600000302540000900008",
    s: "278415369539628714461793825384259176752164983916837452823541697697382541145976238",
    d: 58000000,
  },
  {
    p: "070531400090000007004090000800004100000000003047620000000080602000000000020016700",
    s: "278531469591462837364897521832954176659178243147623958413785692786249315925316784",
    d: 58000000,
  },
  {
    p: "000000061590000020100000009805090036000007400760030000000170004080009050300048000",
    s: "278954361594316827136782549845291736923867415761435298652173984487629153319548672",
    d: 58000000,
  },
  {
    p: "000000006003500010800007400000005060090000300010306070060000090007608020005104000",
    s: "279413856643589712851267439384975261796821345512346978468752193137698524925134687",
    d: 58000000,
  },
  {
    p: "209010036000040000086000000000700013050090600000600507003900008000400050125000300",
    s: "279518436531246879486379125864725913357194682912683547743951268698432751125867394",
    d: 58000000,
  },
  {
    p: "070000400000500000030060000000203100080000000905100038091302070400700500000000010",
    s: "279831465614529387538467921746283159183975246925146738891352674462718593357694812",
    d: 58000000,
  },
  {
    p: "000000000000710008000300694005070020004050800800009006300800000000094000150000000",
    s: "283946175496715238571382694615478923924653817837129546349861752762594381158237469",
    d: 58000000,
  },
  {
    p: "000090053000003001000450000023040900406002800007000000300280070008069200700000080",
    s: "284691753675823491931457628123548967496372815857916342349285176518769234762134589",
    d: 58000000,
  },
  {
    p: "200094000005000070000000008040019005007000060000070000602000000750200100000800003",
    s: "286794531495138672371526948843619725127485369569372814632951487758243196914867253",
    d: 58000000,
  },
  {
    p: "200045609000320000650070010010050000524007000008000000000090008000210740000000005",
    s: "287145639149326587653879412316952874524687391798431256472593168965218743831764925",
    d: 58000000,
  },
  {
    p: "090000080000000900000210007003600002000000370086004000000003000010500004670008090",
    s: "291437685437856921865219437953671842124985376786324159549763218318592764672148593",
    d: 58000000,
  },
  {
    p: "004000000600708020001000003020300506009050102500900300000073000000001060000620400",
    s: "294136857653748921781295643428317596369854172517962384846573219932481765175629438",
    d: 58000000,
  },
  {
    p: "290310000010400000300060000007900580008000070000700300000000002469100005000007000",
    s: "294315867816479253375862194627943581938251476541786329783594612469128735152637948",
    d: 58000000,
  },
  {
    p: "290006007000000040070001020007060000001000004005000890000008600843007002000130000",
    s: "294356187158279346376481925487963251931825764625714893712548639843697512569132478",
    d: 58000000,
  },
  {
    p: "090000070000052001040803002080005010014006009002000000000180090328000000000000000",
    s: "295641378837952461641873952783295614514736829962418735456187293328569147179324586",
    d: 58000000,
  },
  {
    p: "000000000000002053000514902400070290501000800009000000900100030004080000070300600",
    s: "295738164148962753637514982463871295521493876789256341956127438314689527872345619",
    d: 58000000,
  },
  {
    p: "090500003000940060100000500000028000780059000000000720050060840020007000000100000",
    s: "296571483835942167174836592413728659782659314569314728957263841621487935348195276",
    d: 58000000,
  },
  {
    p: "096001000005000007000009050000100040800000209700004001000000005970020030004600020",
    s: "296751384435268917187349652659172843841536279723984561362817495978425136514693728",
    d: 58000000,
  },
  {
    p: "006015000080000900015007002000006001070502800800000020050100300000000070064003000",
    s: "296815437387264915415937682523486791671592843849371526752148369138659274964723158",
    d: 58000000,
  },
  {
    p: "000900000006300790400002006034670000605000420100000000000000000501030800000085940",
    s: "312967584856341792497852316234678159675193428189524673948716235521439867763285941",
    d: 58000000,
  },
  {
    p: "000000006009013020875000300201000600080504200000290000003007005100059000000000000",
    s: "312975846469813527875642391241738659987564213536291478693427185128359764754186932",
    d: 58000000,
  },
  {
    p: "000200609408000007702900000057040000804609002000000003000000310600800004000000090",
    s: "315274689498536127762981435957342861834619572126758943589427316671893254243165798",
    d: 58000000,
  },
  {
    p: "010000090040000250009600004050070000000080600001043507000035800000000040098700000",
    s: "315428796746391258289657134853176429472589613961243587624935871137862945598714362",
    d: 58000000,
  },
  {
    p: "310008009000000000008075200002009006040507010007010000800046000020000150000000000",
    s: "315628749276194385498375261182439576943567812567812493851246937629783154734951628",
    d: 58000000,
  },
  {
    p: "000700000008405100700000050023000904000690500800000003001009002000008000430000000",
    s: "315786249968425137742931856523817964174693528896254713681549372257368491439172685",
    d: 58000000,
  },
  {
    p: "000040000029700800000000031008001000400600005001027000070060004003008600000090070",
    s: "316842597529713846784956231258431769437689125691527483872365914943178652165294378",
    d: 58000000,
  },
  {
    p: "310840200708600000900000010005000300000970450060000001000000040007010000604002000",
    s: "316849275758621934942357618875164329123978456469235781281796543597413862634582197",
    d: 58000000,
  },
  {
    p: "000005208000600010709080000002000000038000400000003000073160000900030520000400003",
    s: "316945278845627319729381645652894137138576492497213856573162984964738521281459763",
    d: 58000000,
  },
  {
    p: "000000040020000079005030001170009000000000006800502000050080400009100000706000800",
    s: "317296548628451379945738621173869254592374186864512937251687493489123765736945812",
    d: 58000000,
  },
  {
    p: "010000200000090003500024080009030504004000070200705060000008000960000400001000006",
    s: "317586249842197653596324187679831524154962378283745961435618792968273415721459836",
    d: 58000000,
  },
  {
    p: "300000700006380100790000000040000070000000420901200030000004000005001004000032008",
    s: "318469752526387149794125683842513976653798421971246835139854267285671394467932518",
    d: 58000000,
  },
  {
    p: "000400600450090180200030000000010000083500270000000000000000001840000500700280304",
    s: "319478652457692183268135749926817435183549276574326918632754891841963527795281364",
    d: 58000000,
  },
  {
    p: "000070000800000904470800100702400000010007500003108000006000051030000060180000000",
    s: "321974685865312974479865132752439816918627543643158297296783451534291768187546329",
    d: 58000000,
  },
  {
    p: "000074050000060700040008001802000905003000000009000068000000000200300070150082600",
    s: "321974856985261743746538291872643915563819427419725368634197582298356174157482639",
    d: 58000000,
  },
  {
    p: "300107600000000100900000002050706080600030050100800306000000000508090040004000003",
    s: "325147698847269135961385472453726981682931754179854326236478519518693247794512863",
    d: 58000000,
  },
  {
    p: "005004007000070205901000000600000000000060003080307050009040000000009508108005920",
    s: "325684197846971235971253486613598742597462813482317659259846371734129568168735924",
    d: 58000000,
  },
  {
    p: "300905001000020040470068900000390000280004000050000000700400020900001406000000003",
    s: "326945781891723645475168932647392158289514367153687294718436529932851476564279813",
    d: 58000000,
  },
  {
    p: "000000009085000000001702500700400093008070000400000601200801000000900040030000006",
    s: "327685419685194327941732568752416893168379254493528671274861935816953742539247186",
    d: 58000000,
  },
  {
    p: "020007000000003900001000305000000810400600090005000000800700000260000007500840060",
    s: "328597641756413928941268375692375814437681592185924736814736259263159487579842163",
    d: 58000000,
  },
  {
    p: "020005000004000107006900005000001000009670000180002900270050036000300008003000000",
    s: "328715649594263187716984325652491873439678251187532964271859436945326718863147592",
    d: 58000000,
  },
  {
    p: "008000700009040800400012000040050230000000100030090000906500070004080000070000060",
    s: "328965741519347826467812395741658239695273184832194657986531472254786913173429568",
    d: 58000000,
  },
  {
    p: "020050060000000039067092000000000000400000051030840007000400000140067005000020003",
    s: "329154768514786239867392514795613482486279351231845697952438176143967825678521943",
    d: 58000000,
  },
  {
    p: "000000400008500000760800200201600800000000030070001005080020060097030000000018000",
    s: "329167458418592376765843219231659847856274931974381625183925764597436182642718593",
    d: 58000000,
  },
  {
    p: "040007025200000800600000100007082003800900710000100000004050300905040000000000002",
    s: "341867925279513846658429137417682593862935714593174268124756389935248671786391452",
    d: 58000000,
  },
  {
    p: "001020006000004901000030080000002000000701000502409000030000708009800003400000060",
    s: "341928576258674931976135482714362895893751624562489317135296748629847153487513269",
    d: 58000000,
  },
  {
    p: "000000080009021000080500006000030005003017040807000000490000052700200000020000017",
    s: "345769281679821534182543976914638725253917648867452193498176352731285469526394817",
    d: 58000000,
  },
  {
    p: "006082007050007000010300400020010000000000004400050300007040020030800600200900801",
    s: "346182597859467132712395468523614789691738254478259316187546923934821675265973841",
    d: 58000000,
  },
  {
    p: "300090008020800009005300140074005010030000000000900200000002080800460005000000700",
    s: "346291578721854639985376142274685913639127854158943267593712486817469325462538791",
    d: 58000000,
  },
  {
    p: "007050120000000009060004870020703060001060040000000000000038200810000000000000704",
    s: "347859126258176439169324875425713968781965342693482517974638251812547693536291784",
    d: 58000000,
  },
  {
    p: "040000010100080032007013000072000000000000084060000290400000300003900600006700008",
    s: "348529716195687432627413859572894163931276584864351297489162375753948621216735948",
    d: 58000000,
  },
  {
    p: "008000000000005430060830000000000020090600100000241050000500000000093070019002003",
    s: "348927615927165438561834792154379826293658147876241359732516984685493271419782563",
    d: 58000000,
  },
  {
    p: "040007050006010709000000600080300900009605007000000020001400000070009008000208003",
    s: "348967251256814739917523684785342916129685347463791825831476592572139468694258173",
    d: 58000000,
  },
  {
    p: "349000005000000010000000040100420760600000500000080003008001009002365000001090000",
    s: "349612875257834916816957342195423768683179524724586193568741239972365481431298657",
    d: 58000000,
  },
  {
    p: "040020000000803000100007306500002009090081000600300100960000200407090050005000403",
    s: "349625718276813945158947326514762839793481562682359174961534287437298651825176493",
    d: 58000000,
  },
  {
    p: "049000007760010408800000005900620700004008300002009000000130000008005000006000010",
    s: "349852167765913428821764935983621754614578392572349681257136849138495276496287513",
    d: 58000000,
  },
  {
    p: "001090060840100050000408000005000008000600000700030006069070000010000700530000009",
    s: "351297864842163957976458213625719348193684572784532196269375481418926735537841629",
    d: 58000000,
  },
  {
    p: "050709004060200050040000600003095000000000010008006700000003000090050071400000009",
    s: "351769824769248153842531697673195248524387916918426735185973462296854371437612589",
    d: 58000000,
  },
  {
    p: "302000009910305070004000010860000004005710000000000000000000500503096000006801030",
    s: "352167489918345276674982315867539124425718693139624857291473568583296741746851932",
    d: 58000000,
  },
  {
    p: "050001000007000032000020004400009000008730000070000090003000800000065100000012400",
    s: "352471986147698532869523714431289657598736241276154398613947825924865173785312469",
    d: 58000000,
  },
  {
    p: "000000400000409003800031072700200005504000090620007000000002000031700000007000908",
    s: "352876419176429853849531672798214365514683297623957184985362741431798526267145938",
    d: 58000000,
  },
  {
    p: "000000200000030070060870300005040009400009700000000062704500000009360005080000000",
    s: "357416298148932576962875314675243189421689753893751462734598621219367845586124937",
    d: 58000000,
  },
  {
    p: "007010000209005000400070600940050003020600041000001020000003002700000900005004000",
    s: "357416298269835417418972635941257863523689741876341529684593172732168954195724386",
    d: 58000000,
  },
  {
    p: "000060400200000000106050000680000070000016004000940002700008020020000000030000508",
    s: "358269417297184635146753289684325971972816354513947862765498123829531746431672598",
    d: 58000000,
  },
  {
    p: "008400090000005470100000000060093007000070000820000000000000300000680000689204000",
    s: "358467192296315478174928653561893247943572861827146539412759386735681924689234715",
    d: 58000000,
  },
  {
    p: "000760000460510000000000750040300080100000900000070000000003068031098200800000009",
    s: "358769412467512893219834756945321687173486925682975341794253168531698274826147539",
    d: 58000000,
  },
  {
    p: "305000020000090000007200006000600098000000003000189002800000004001400070600005010",
    s: "365874921218596437497231586742653198189742653536189742853917264921468375674325819",
    d: 58000000,
  },
  {
    p: "000400008000000900000300650004000570005020000003000084801009000200016000700008000",
    s: "367495218518672943492381657984163572175824369623957184831549726249716835756238491",
    d: 58000000,
  },
  {
    p: "000000140080709003000000000509200008030000050040093007004000005096080000700001002",
    s: "367852149481769523925134876579216438632478951148593267814627395296385714753941682",
    d: 58000000,
  },
  {
    p: "300000010070006902000059006000500100730000000090340500200000049000002000900800000",
    s: "369284715574136982812759436428567193735921864691348527287615349153492678946873251",
    d: 58000000,
  },
  {
    p: "000000000001002693087030400013008020000710040900000500026040000000005900000006000",
    s: "369451287541872693287639415413598726652713849978264531126947358734185962895326174",
    d: 58000000,
  },
  {
    p: "000000004020490000800052700005030000000060040000005910098500000004000031600070408",
    s: "369718254527496183841352769715934826982167345436825917198543672274689531653271498",
    d: 58000000,
  },
  {
    p: "060027000700410900000000000030700190000030406500060080040000070003100600102390000",
    s: "369827514725413968481659237638745192217938456594261783946582371853174629172396845",
    d: 58000000,
  },
  {
    p: "070000000500190407800050001060023070000500009200000000047060000003000000000900010",
    s: "371642598526198437894357621469823175738516249215479386947261853153784962682935714",
    d: 58000000,
  },
  {
    p: "000060000009007086004200100000040020000000790503009000030050000426000000000008030",
    s: "371864259259137486864295173987546321642381795513729864138652947426973518795418632",
    d: 58000000,
  },
  {
    p: "070000000090600000486030000000504010000000400020080907200003008008070250000060030",
    s: "372918546195647382486235179769524813813796425524381967247153698638479251951862734",
    d: 58000000,
  },
  {
    p: "005200060040000020000030700050600100010047600090000008008703001007000005000009000",
    s: "375214869149876523682935714254698137813547692796321458968753241437162985521489376",
    d: 58000000,
  },
  {
    p: "070108002000000300000200006690004003024000000005700900003000200040800090802007000",
    s: "376198452281645379459273816698514723724389165135726948963451287547832691812967534",
    d: 58000000,
  },
  {
    p: "300008020000300076000700400009000100700069005500070200100042000000005000080000009",
    s: "376458921945321876821796453239584167714269385568173294157942638693815742482637519",
    d: 58000000,
  },
  {
    p: "070002000000000000080300560000050107205006900040209005600000004197000000008060390",
    s: "376542819512698473984317562869453127235176948741289635653921784197834256428765391",
    d: 58000000,
  },
  {
    p: "000100000060004503005600800003960000000003078109000000620000004000007020800000009",
    s: "378159462962874513415632897783965241256413978149728635627591384594387126831246759",
    d: 58000000,
  },
  {
    p: "000006040210080006069100000006007000020300000003500417000800065000005800001000700",
    s: "378956142215784936469123578156497283724318659893562417942871365637245891581639724",
    d: 58000000,
  },
  {
    p: "370000400000507000006900001000480070004000600003000204010200090800070050000090000",
    s: "379816425128547963546932781261483579954721638783659214415268397892374156637195842",
    d: 58000000,
  },
  {
    p: "000000009070000010406070500600301008000080000035200000204000080090004076000800050",
    s: "382145769579632814416978523647351298921487635835296147254763981198524376763819452",
    d: 58000000,
  },
  {
    p: "080070009000000000007029030000005600700038000000092053609001000003000106470000000",
    s: "382174569914563782567829431238415697795638214146792853659241378823957146471386925",
    d: 58000000,
  },
  {
    p: "004050001000049080000300062006095000070010050800200000003000070600500000095000300",
    s: "384652791267149583519378462436795218972813654851264937143926875628537149795481326",
    d: 58000000,
  },
  {
    p: "304607500000000890062000000000903005040010200800000900000005000600074000000320007",
    s: "384697512751432896962581374126943785549718263873256941297165438635874129418329657",
    d: 58000000,
  },
  {
    p: "084700500560040000000000000000000200008019000000380006030001700800005001042006000",
    s: "384762519569143872721598643413657298658219437297384156935821764876435921142976385",
    d: 58000000,
  },
  {
    p: "300020000009100802070000904040079000003006000700080500000300010050000009000000007",
    s: "385924671469137852271865934846579123593216748712483596627398415158742369934651287",
    d: 58000000,
  },
  {
    p: "006007900090030100250008600020080003000500000040200010007060000000300459000000000",
    s: "386157942794632185251948637129784563678513294543296718937465821862371459415829376",
    d: 58000000,
  },
  {
    p: "000009004000004600002000580008713000230040000000500000500800016060000037000300050",
    s: "386159724175284693942637581658713942237948165419526378593872416861495237724361859",
    d: 58000000,
  },
  {
    p: "006009205500004703000030000000700910060000002702040080608400000000090000100860050",
    s: "386179245591284763247635891853726914964518372712943586628457139475391628139862457",
    d: 58000000,
  },
  {
    p: "300000204000800070025703000000006000940000000050020300060090007000258100002000080",
    s: "387569214619842573425713698271436859943185762856927341568391427794258136132674985",
    d: 58000000,
  },
  {
    p: "380600005000000736000010000000800070000060001000041083090003060100000020002905000",
    s: "387694215914258736256317894561839472843762951729541683498123567175486329632975148",
    d: 58000000,
  },
  {
    p: "089000000001090005007000200900407000006005083000002400008000540000503010000008000",
    s: "389256174621794835457831269913487652246915783875362491138629547762543918594178326",
    d: 58000000,
  },
  {
    p: "090000000400000023006004000050700000003000605080040000000009050900020300012530080",
    s: "391257468478961523526384791659713842143892675287645139834179256965428317712536984",
    d: 58000000,
  },
  {
    p: "090000051080004030007090800000700200000908170500200000002630094000005012000000000",
    s: "396872451281564937457391826139746285624958173578213649812637594963485712745129368",
    d: 58000000,
  },
  {
    p: "090001200000035600106000000009000020000703180720000004000180000460000030000000008",
    s: "397861245284935617156472893839514726645723189721698354573189462468257931912346578",
    d: 58000000,
  },
  {
    p: "000000007590040000763900000040507200000030600000010005900000706025000003670003010",
    s: "412365897598741362763928154146587239257439681389612475931854726825176943674293518",
    d: 58000000,
  },
  {
    p: "402080000006090017090001003000000008200040100301500706000000000003700000008260000",
    s: "412387965536492817897651423649173258275846139381529746164938572923715684758264391",
    d: 58000000,
  },
  {
    p: "400090000000600001009005740000200000000080200280000500800706005604000000520100008",
    s: "412397856758642391369815742145279683976583214283461579891726435634958127527134968",
    d: 58000000,
  },
  {
    p: "410090000000600000600000200000030059008009100900000064002080036000400000000100005",
    s: "415297683723648591689351247261734859348569172957812364172985436596423718834176925",
    d: 58000000,
  },
  {
    p: "000000000062700000700060305000001000000079400084030100030600040041080060000500000",
    s: "415328976362795814798164325273451698156879432984236157837612549541987263629543781",
    d: 58000000,
  },
  {
    p: "006000007000004120500000004069000080000003009000810000200090400030020500908700200",
    s: "416382957783954126592176834169247385824563719375819642251698473637421598948735261",
    d: 58000000,
  },
  {
    p: "400006003070004100000700080100000030000502907000600000001009700000020040539000008",
    s: "418296573673854192952731684126978435384512967795643821241389756867125349539467218",
    d: 58000000,
  },
  {
    p: "000000002006004500705109300109380000080000000500002003800000000300657900000000200",
    s: "418573692936824517725169348169385724283746159574912863857291436342657981691438275",
    d: 58000000,
  },
  {
    p: "001030970000000500000720003009000000800040002014500008600000000795000040000006000",
    s: "421835976378691524956724813539218467867943152214567398643179285795382641182456739",
    d: 58000000,
  },
  {
    p: "005081000060900005970000000000000030000402700000730400030020800001000600502000091",
    s: "425381976163974285978256143714698532359412768286735419637129854891543627542867391",
    d: 58000000,
  },
  {
    p: "406307000000020000700056002000000045869000001004000009100040000078009050000270000",
    s: "426317598953824176781956432237691845869435721514782369192543687378169254645278913",
    d: 58000000,
  },
  {
    p: "000000570080230006030000000009600007004500200000100360140980000000040080000000601",
    s: "426819573581237496937465128319624857864573219275198364142986735653741982798352641",
    d: 58000000,
  },
  {
    p: "006000719000010050000200000040006890070000003809420000900080000030500000001000204",
    s: "426835719798614352153279648342756891675198423819423567964382175237541986581967234",
    d: 58000000,
  },
  {
    p: "000701300700000020009005080001007004005400009000500060600200000030000000090046005",
    s: "428791356756834921319625487261987534875463219943512768687259143534178692192346875",
    d: 58000000,
  },
  {
    p: "030000098080140000600000000000805000050000910201903050004200700900000500003006004",
    s: "432657198785149326619328475397815642856472913241963857564281739928734561173596284",
    d: 58000000,
  },
  {
    p: "030010000792004000006000049070005080009843000000000301000097500000000090007500600",
    s: "435719862792684135186352749673125984519843276824976351268497513351268497947531628",
    d: 58000000,
  },
  {
    p: "030000000080600430600030002060027000301008000008050009509200340000000000000005100",
    s: "437582961182679435695431782964127853351968274728354619579216348216843597843795126",
    d: 58000000,
  },
  {
    p: "407001600080009000900000420000500006100080000004270800002000100806000700070000004",
    s: "437821659285649371961357428728514936153986247694273815542798163816435792379162584",
    d: 58000000,
  },
  {
    p: "000000005008390420091006000100580002004000000000000570800170000760009084000000000",
    s: "437821965658397421291456837179583642584762319326914578843175296765239184912648753",
    d: 58000000,
  },
  {
    p: "030000050108000043000400007000910002300085000015020060570000000004009030003062000",
    s: "437896251198257643652431897746913582329685714815724369571348926264579138983162475",
    d: 58000000,
  },
  {
    p: "000001600060000040000009508000100000003024010200308000905070003800030900302000000",
    s: "438251679569783241127649538684197352793524816251368794945872163816435927372916485",
    d: 58000000,
  },
  {
    p: "008201000000090000200300406007000368000980005300010000000000009000740200054030000",
    s: "438261597576498132219375486197524368642983715385617924723156849861749253954832671",
    d: 58000000,
  },
  {
    p: "408000200000300090070040050002004000000150000000080001000000006805090000003006520",
    s: "438519267651327498279648153312964785786153942594782631927435816865291374143876529",
    d: 58000000,
  },
  {
    p: "400000009000010040008000500009600003000020050000175020000007090000000008010250000",
    s: "451732689967518342238496571529684713174923856683175924342867195795341268816259437",
    d: 58000000,
  },
  {
    p: "000001090007480500083020000200300008500006000000000604040060100000800000000007030",
    s: "452671893917483526683529741264315978598746312731298654345962187179834265826157439",
    d: 58000000,
  },
  {
    p: "000000000600100085780620000005370000100000076000400000500708010804001009300000000",
    s: "452983167639147285781625394265379841143852976978416523596738412824561739317294658",
    d: 58000000,
  },
  {
    p: "003060098000500000000000020500010200180000000000009073000600900000408007701000030",
    s: "453162798972583461816947325539714286187326549624859173348671952295438617761295834",
    d: 58000000,
  },
  {
    p: "053090800801600300000000407000020000007409080060037000004008000000006005000500100",
    s: "453792861871654329692381457948125673137469582265837914514978236389216745726543198",
    d: 58000000,
  },
  {
    p: "400801000002000510000036002600000007300070900204000000009400800000600105000080000",
    s: "456821739832947516917536482691358247385274961274169358569412873748693125123785694",
    d: 58000000,
  },
  {
    p: "007000000000409002320070540006003800801000000000090000000200010002080600900060305",
    s: "457326189618459732329178546246513897891647253573892461765234918132985674984761325",
    d: 58000000,
  },
  {
    p: "050610000000000900080302040540000002000000600720006300100005020030000087000007000",
    s: "457619238312478965689352741546793812893521674721846359178935426935264187264187593",
    d: 58000000,
  },
  {
    p: "000006010200080006000500409530000008904700000021000050106009300005070020000000001",
    s: "458396217219487536763512489537261948984735162621948753146829375895173624372654891",
    d: 58000000,
  },
  {
    p: "000800600000003005106000000302000700500090040000002090003608000000304900708009050",
    s: "459821637827963415136547829392485761581796243674132598943658172215374986768219354",
    d: 58000000,
  },
  {
    p: "000380900390267040720001000000000000000009480080010060600470005207600100000000000",
    s: "461385927395267841728941356534826719176539482982714563619478235247653198853192674",
    d: 58000000,
  },
  {
    p: "060080070009300000002040001090000520005000410006008000500920030010000000000071000",
    s: "461582379859317642732649851397164528285793416146258793578926134914835267623471985",
    d: 58000000,
  },
  {
    p: "000700000305006700800205060100060300057000000002500001000450020040008000206000000",
    s: "461789532325146789879235164184962375957813246632574891798451623543628917216397458",
    d: 58000000,
  },
  {
    p: "402000009000062804030000500000000000706054000020300080080000001070100008200090060",
    s: "462583179195762834837941526348279615716854392529316487984637251673125948251498763",
    d: 58000000,
  },
  {
    p: "002000105000900000010460800900040000053008700600000032000200050000000047000010600",
    s: "462783195538921476719465823971342568253698714684157932846279351195836247327514689",
    d: 58000000,
  },
  {
    p: "400900700100000008005402000050048000007010680030000102000050000000000460000300007",
    s: "462981735179635248385472916651248379927513684834796152746159823593827461218364597",
    d: 58000000,
  },
  {
    p: "000000005035004000007003040008000001000000200920108000604070009070040000000502100",
    s: "462987315835614792197253648548726931713495286926138457654371829271849563389562174",
    d: 58000000,
  },
  {
    p: "000000070008000401501800000000060007100004006950070200000000030005300902084000000",
    s: "463521879728639451591847623842965317137284596956173284219456738675318942384792165",
    d: 58000000,
  },
  {
    p: "060002000200000500700061030004020600830900000009000058007300000000058100000610000",
    s: "463592817291783564758461932174825693835976421629134758517349286346258179982617345",
    d: 58000000,
  },
  {
    p: "000700000020040030500060010200104000006080700009300000610000000000009460050000000",
    s: "463721859821945637597863214275194386346582791189376542612458973738219465954637128",
    d: 58000000,
  },
  {
    p: "000008000190000047020000100700001200800300900006000003000000036000104000300502080",
    s: "467918352198253647523647198734891265852376914916425873241789536685134729379562481",
    d: 58000000,
  },
  {
    p: "068000075000300000000006000020040010007900040900028000070004060802003000009500800",
    s: "468219375291357684735486129326745918587931246914628753173894562852163497649572831",
    d: 58000000,
  },
  {
    p: "068000005000203000039460000000026070050000902070000010090807021000010006000000400",
    s: "468791235715283649239465187981326574354178962672954813596847321843512796127639458",
    d: 58000000,
  },
  {
    p: "471000890005000000080000300000060019806041070004000080600010002000200000000507060",
    s: "471352896365189724289674351723865419856941273914723685697418532538296147142537968",
    d: 58000000,
  },
  {
    p: "000000060103090020050200070007000694008300100000609007005000000020750000900012000",
    s: "472538961163497528859261473237185694698374152514629387785943216321756849946812735",
    d: 58000000,
  },
  {
    p: "000000601005000400010040000000900006800701009007006020004000870000030200059200000",
    s: "478392651935167482216845937542983716863721549197456328624519873781634295359278164",
    d: 58000000,
  },
  {
    p: "070560010003040000050300000000000900009000802000080003060030024500000000780001600",
    s: "478562319293147586156398247827453961349716852615289473961835724532674198784921635",
    d: 58000000,
  },
  {
    p: "000106005073000900100002000031000607000000028060000000000001030000040706840960000",
    s: "482196375673854912195372864931528647754639128268417593526781439319245786847963251",
    d: 58000000,
  },
  {
    p: "005200007070000090000760080040003010008000400000000608920000000030000170006005000",
    s: "485291367671538294392764581249683715768152439153947628927416853534829176816375942",
    d: 58000000,
  },
  {
    p: "005913000006500080000000000000470600200001000049000020800060000010004007000000091",
    s: "485913276396527184721846935538472619267391548149685723874169352913254867652738491",
    d: 58000000,
  },
  {
    p: "080007560300000000000593000201000000000020640034005700000000001000040070017000090",
    s: "489217563375864129162593487251476938798321645634985712946738251523149876817652394",
    d: 58000000,
  },
  {
    p: "400000000006008405030400000005010000790060050008000009070009601003600004000073002",
    s: "489251367216738495537496128325917846791864253648325719872549631153682974964173582",
    d: 58000000,
  },
  {
    p: "000720000061490000050080400230500000000000204045000000890016005000900100000070069",
    s: "489725631761493582352681497238547916176839254945162378894316725627958143513274869",
    d: 58000000,
  },
  {
    p: "000000020067008000300120067850010000710400000040006002000801590000000804000000000",
    s: "491567328267398451385124967856213749712489635943756182624871593579632814138945276",
    d: 58000000,
  },
  {
    p: "091008005060900030000040006006009000089007010000200800050300000100000702000084000",
    s: "491638275867925431523741986346819527289457613715263894954372168138596742672184359",
    d: 58000000,
  },
  {
    p: "000807600300400000052003100900000540005000008000000007000100000068000300130020096",
    s: "491857632376412859852693174987261543215374968643985217729136485568749321134528796",
    d: 58000000,
  },
  {
    p: "000007001800020090006000804020060009900035780008009000500008000000500670040000000",
    s: "492387561851426397376951824725864139914235786638179245563798412189542673247613958",
    d: 58000000,
  },
  {
    p: "002081003007000108000020000200050430000600000006004780900000050040102000300005000",
    s: "492581673657349128183726945219857436874613592536294781921468357745132869368975214",
    d: 58000000,
  },
  {
    p: "492650817816974253735821000569310478178465000000798000000086740087549030000037080",
    s: "492653817816974253735821694569312478178465329324798561953186742287549136641237985",
    d: 58000000,
  },
  {
    p: "000006080000500000075008040030700200200009003040000000900300560007000091081000000",
    s: "493276185862541937175938642538764219216859473749123856924317568657482391381695724",
    d: 58000000,
  },
  {
    p: "090000000200058000060320000000000210009040600017000038800007001072000000000009300",
    s: "495176823231958764768324195684735219329841657517692438853267941972413586146589372",
    d: 58000000,
  },
  {
    p: "000807000306010970000060003070000090080590000004003100000200700000000005061070000",
    s: "495837261326415978718962453173648592682591347954723186839256714247189635561374829",
    d: 58000000,
  },
  {
    p: "000000000000490210008735000000050000030014006007900350600140800059000000004000000",
    s: "496281537375496218218735964961357482532814796847962351623149875759628143184573629",
    d: 58000000,
  },
  {
    p: "400000080002600049007004500008100000010530002070000091000060020309000004600023000",
    s: "496315287152687349837294516268179435914536872573842691785461923329758164641923758",
    d: 58000000,
  },
  {
    p: "496080200000001650080000000302000940000020300000000000000900007800007020700500004",
    s: "496785231237491658581263479312876945975124386648359712124938567859647123763512894",
    d: 58000000,
  },
  {
    p: "007100800001900000600007010540000000700030006020000305000002083005000000000069070",
    s: "497156832831924657652387419543691728789235146126478395964712583275843961318569274",
    d: 58000000,
  },
  {
    p: "000210003000004000010030400000053000930800705200009000700000506500090010300600080",
    s: "497218653653974128812536479176453892934821765285769341749182536568397214321645987",
    d: 58000000,
  },
  {
    p: "400001000002000000075600300800035000700000604000000900000900008004020001980000006",
    s: "498351267632749815175682349869435172723198654541267983216974538354826791987513426",
    d: 58000000,
  },
  {
    p: "000070000050000004600300500004009000260000309010805007176008003800000970000010000",
    s: "498571632351682794627394518784239165265147389913865247176928453832456971549713826",
    d: 58000000,
  },
  {
    p: "000400000048000070000010800600300005200000003001007000004000017050090000090002080",
    s: "512478369348956271967213854679384125285169743431527698824635917756891432193742586",
    d: 58000000,
  },
  {
    p: "010000807090034000800000000007000040380001002000002060002390070000250000035000000",
    s: "514629837796834125823715694267583941389461752451972368142398576978256413635147289",
    d: 58000000,
  },
  {
    p: "014700003006900500000000106031000020405000900000178000000040000090002030000001080",
    s: "514726893386914572729835146831459627475263918962178354158347269697582431243691785",
    d: 58000000,
  },
  {
    p: "000000390000003001096000070087100230130400000000007000070600804000070100009002000",
    s: "514768392728953641396241578487195236135426987962387415271639854653874129849512763",
    d: 58000000,
  },
  {
    p: "010000000093070501000080070006000000000204860000800090035100400200908005000700000",
    s: "517439628893672541624581973486397152359214867172865394735126489261948735948753216",
    d: 58000000,
  },
  {
    p: "500900600008000000000020081000300000009400502400000090001000053080040070050630100",
    s: "517983624268714935394526781175392468839467512426851397641279853983145276752638149",
    d: 58000000,
  },
  {
    p: "008060000900001000060590080009027500000030702000009030056003020002600007000000004",
    s: "518364279923781645764592183639427518845136792271859436456973821192648357387215964",
    d: 58000000,
  },
  {
    p: "001309000600007080730000002200006007010000090005000000350000008060090300000005600",
    s: "521389764694217583738564912283956147416723895975148236359671428867492351142835679",
    d: 58000000,
  },
  {
    p: "020400000003005010000102000305071000102803900089004000000000700400000652050000030",
    s: "521487396873695214694132587365971428142863975789524163216358749438719652957246831",
    d: 58000000,
  },
  {
    p: "000030070069002004000000003907300050080000020000056000006100000800009001140700000",
    s: "521634978369872514478591263917328456685417329234956187796145832853269741142783695",
    d: 58000000,
  },
  {
    p: "500000400060080000408070000802000905000002003009000000010760004000000001007309506",
    s: "521693478763284159498571632832147965674952813159836247915768324386425791247319586",
    d: 58000000,
  },
  {
    p: "000600100907000000300025000003070000000501406000008010840010005000004067005000300",
    s: "524689173967143258381725694413276589278591436659438712846317925132954867795862341",
    d: 58000000,
  },
  {
    p: "020903000400702008000000000040000900060000703005260000100000005008009030000801400",
    s: "526983147419752368387614592742138956861495723935267814194376285278549631653821479",
    d: 58000000,
  },
  {
    p: "020100003000700000010050700000602000009005400006049000300000000070000850600008100",
    s: "527194683964783512813256749748612395239875461156349278381567924472931856695428137",
    d: 58000000,
  },
  {
    p: "020304900809200000000080000070040020000000703035007000050000800040620001000000009",
    s: "527314986819276354364589217678943125491852763235167498756491832943628571182735649",
    d: 58000000,
  },
  {
    p: "020010400010805072300000000000000010000604059975000006000009000009501000800030000",
    s: "527316498614895372398742165462958713183674259975123846731269584249581637856437921",
    d: 58000000,
  },
  {
    p: "007093000803620790060700000438900270600000900000000600000104005200300080000000000",
    s: "527493816813625794964718532438956271672841953159237648796184325245369187381572469",
    d: 58000000,
  },
  {
    p: "020096030007000000000007540700002300486050010000000000000000900802041000091000050",
    s: "528496137947135286163827549715682394486359712239714865374568921852941673691273458",
    d: 58000000,
  },
  {
    p: "001000400000007020200403006050906000080700000000015700425000000008021003000000060",
    s: "531268497846197325297453816754986231183742659962315784425639178678521943319874562",
    d: 58000000,
  },
  {
    p: "500000000000104030806200901075008000010000000000000247004090300000300025000006800",
    s: "531689472297154638846237951975428163412763589368915247754892316689341725123576894",
    d: 58000000,
  },
  {
    p: "002069040007000000006470009000506000000000093041000870809003000320000060000600080",
    s: "532169748497328516186475239973586124258741693641932875869213457324857961715694382",
    d: 58000000,
  },
  {
    p: "000010000080003605074900000300206010100000004200001007020000540000000000000039000",
    s: "532618479981743625674952831345276918197385264268491357829167543753824196416539782",
    d: 58000000,
  },
  {
    p: "030001020400003700000700080000000500160000430000029000900500300805000000000016000",
    s: "537681924481293765692745183278364519169857432354129876926578341815432697743916258",
    d: 58000000,
  },
  {
    p: "000009140400000000080200509090000006003000800802050010208900000040003070305000000",
    s: "537689142429531687681274539194328756753196824862457913278945361946813275315762498",
    d: 58000000,
  },
  {
    p: "008000070002970500400005000000039000300006700020000090000080000040300100900200360",
    s: "538142679162973584497865231714539826389426715625718493253681947846397152971254368",
    d: 58000000,
  },
  {
    p: "500000070490000106007900000000005041803020060000081703005007000000048000700030000",
    s: "538416972492873156167952438276395841813724569954681723385167294629548317741239685",
    d: 58000000,
  },
  {
    p: "509200000070000020000600730020003004003510000000007010800000000000004905400109200",
    s: "539271486176348529284695731721983654643512897958467312892756143317824965465139278",
    d: 58000000,
  },
  {
    p: "000098000016700200007203000600000074003004006020000000700030005800000900005000100",
    s: "542198763316745298987263451659821374173954826428376519791432685864517932235689147",
    d: 58000000,
  },
  {
    p: "040006007083000002000200586001000000050070200000005610000500900090040700020080000",
    s: "542896137683751492719234586231469875956178243874325619467513928398642751125987364",
    d: 58000000,
  },
  {
    p: "540060000100003080008400090000002960030000200000056870450001000000270500070040000",
    s: "543869127197523486628417395785132964936784251214956873452691738361278549879345612",
    d: 58000000,
  },
  {
    p: "040906008092100000070000040000009020001800409000320600007000030000080062010400000",
    s: "543976218892143756176258943468719325321865479759324681287691534934587162615432897",
    d: 58000000,
  },
  {
    p: "040800013007000008900046070001080006800050000000030050000200000090001000300000600",
    s: "546827913237915468918346572451789236823654197769132854185263749692471385374598621",
    d: 58000000,
  },
  {
    p: "500908010000040080000030000300000000062010000000009765004001050070000020105800906",
    s: "547968213213547689896132574359786142762415398481329765634291857978653421125874936",
    d: 58000000,
  },
  {
    p: "540020090006000100009000600600309004001000500430060200000000450100500060007800000",
    s: "548621793726493185319785642672359814891274536435168279263917458184532967957846321",
    d: 58000000,
  },
  {
    p: "048600200000700408900050000030009006700000500000000090600000000007200080010008604",
    s: "548631279361792458972854361834529716729186543156347892683415927497263185215978634",
    d: 58000000,
  },
  {
    p: "560830000300050610002010000000003000008591400040000090000208360470000000000000700",
    s: "561837249384952617792614835917423586638591472245786193159278364473165928826349751",
    d: 58000000,
  },
  {
    p: "000031700000600003400000065030900800020004006600500010080200000346000580007000000",
    s: "562431798718659423493872165135926874829714356674583219981245637346197582257368941",
    d: 58000000,
  },
  {
    p: "002030010917000400000700000038400005040000296000002800004050960000000000700340000",
    s: "562934718917685423483721659238469175145873296679512834324158967856297341791346582",
    d: 58000000,
  },
  {
    p: "003028074040000006070000000000002600900000130280040000000900003600080000001000700",
    s: "563128974142739856879654321317592648954876132286341597728915463635487219491263785",
    d: 58000000,
  },
  {
    p: "500020800140030000009046007070800200000010705020000068000080009000900001000007000",
    s: "567129834142738596389546127675894213893612745421375968734281659258963471916457382",
    d: 58000000,
  },
  {
    p: "000000710009080006000650003030001000000090080400003020054000090600008500087000400",
    s: "568324719349187256271659843832471965716295384495863127154732698623948571987516432",
    d: 58000000,
  },
  {
    p: "002004000010569000090000500400030000001008059000400302000000820200006070300700000",
    s: "572184936813569247694273581425931768731628459986457312167395824259846173348712695",
    d: 58000000,
  },
  {
    p: "500084000000009307000023001012000840400000070000090002009030008005000010000070600",
    s: "573184269124569387698723451912357846436812975857496132749631528265948713381275694",
    d: 58000000,
  },
  {
    p: "570000400000040501000980000304700002800000070000693004000100000050060000090002610",
    s: "573216498986347521241985736314758962869421375725693184632174859157869243498532617",
    d: 58000000,
  },
  {
    p: "503000000004000000980000004800290003600500070720001800000000068000703000000109005",
    s: "573814926214956387986372514841297653639548271725631849397425168158763492462189735",
    d: 58000000,
  },
  {
    p: "500100000000020000603008450000000060000500030801004000089000700407000000300700290",
    s: "574163982198425673623978451952837164746512839831694527289351746467289315315746298",
    d: 58000000,
  },
  {
    p: "000300009000000326600098070050000060007203000100000008005400803009000000800029000",
    s: "574362189981745326623198574358914267467283915192657438215476893749831652836529741",
    d: 58000000,
  },
  {
    p: "000000104082007005009800000065000307020000500000070000007083000200000003908710040",
    s: "576329184382147695419856732865491327724638519193572468647283951251964873938715246",
    d: 58000000,
  },
  {
    p: "580000300001050008060080200300001000000008603007630090000009000400100980000205000",
    s: "582416379731952468964387215346591827159728643827634591213849756475163982698275134",
    d: 58000000,
  },
  {
    p: "000000000090267030670000000001030702050000060000000804900010000000300005060570100",
    s: "582943617194267538673158429841635792759482361326791854935814276417326985268579143",
    d: 58000000,
  },
  {
    p: "083000094000300000007006001209000500000009006700000020001057000006000000095061007",
    s: "583172694612394785947586231269743518154829376738615429821457963476938152395261847",
    d: 58000000,
  },
  {
    p: "003090000100000002020600018650000807031000450000008000005100000009080000000730105",
    s: "583291674196847532427653918652314897831972456974568321345126789719485263268739145",
    d: 58000000,
  },
  {
    p: "000609001020070000400000080200080700000000853060500009001020037000300000052014000",
    s: "583649271926178345417253986235981764179462853864537129691825437748396512352714698",
    d: 58000000,
  },
  {
    p: "000001030000400007079000000000608000020940000400000010000000100008007250206030079",
    s: "584791632132486597679352481795618324821943765463275918357829146948167253216534879",
    d: 58000000,
  },
  {
    p: "086007023420000060000050090090708000700000000030000059002500000004200005000004080",
    s: "586497123429813567173652894695738412741925638238146759812579346364281975957364281",
    d: 58000000,
  },
  {
    p: "507000290100000000900000180040950000000030000700086000001300700000400806600700003",
    s: "587613294124879365936542187843957621269134578715286439491368752372495816658721943",
    d: 58000000,
  },
  {
    p: "000030000201008009000200056006020007300000480800059000005000600008005100000000040",
    s: "587936214261548739934271856146823597359167482872459361795314628428695173613782945",
    d: 58000000,
  },
  {
    p: "500001000000050934007960000358040010006003000000100006040690005600000800020000000",
    s: "589431762162857934437962581358746219916523478274189356743698125691275843825314697",
    d: 58000000,
  },
  {
    p: "500007008000000920028030006200800000000096000009004050000100004000600000053009067",
    s: "591267438367548921428931576236815749745396182819724653672153894984672315153489267",
    d: 58000000,
  },
  {
    p: "000004800600091000040000009012007005000900402900305000160050070400100000005030200",
    s: "591764823638291547247583169312647985756918432984325716169852374423179658875436291",
    d: 58000000,
  },
  {
    p: "500000200000100867007030000800020001002006009050000020004600090720000030000018000",
    s: "591867243243195867687234915879423651412756389356981724134672598728549136965318472",
    d: 58000000,
  },
  {
    p: "502037000010400009070000000600180305000000910000000000020000800007600003100305000",
    s: "592837461813456729476219538649182375285763914731594682324971856957628143168345297",
    d: 58000000,
  },
  {
    p: "003000007046000050000950020050709080000500009100060700030090004010000030004080000",
    s: "593824167246137958871956423452719386367548219189362745635291874918475632724683591",
    d: 58000000,
  },
  {
    p: "000000000008749000176200000000007000000006103050000090080000350040001076005030080",
    s: "594163827238749615176285439419327568827596143653418792981672354342851976765934281",
    d: 58000000,
  },
  {
    p: "004070683300000000007500091001000070700040100020050000000900030458006000000008000",
    s: "594271683316894752287563491941682375765349128823157946672915834458736219139428567",
    d: 58000000,
  },
  {
    p: "500302010100509000008010900004803002000600000030020000075000000000000067002406000",
    s: "596382714147569283328714956764853192259641378831927645675138429413295867982476531",
    d: 58000000,
  },
  {
    p: "006400008000520000001000900050000070000050000000043016000000207070008400005010000",
    s: "596431728837529164241876935154682379369157842782943516418365297673298451925714683",
    d: 58000000,
  },
  {
    p: "000000000040000020300000806000040005600090040020170090007004000058030900004017050",
    s: "596821437841763529372459816719346285683295741425178693937584162158632974264917358",
    d: 58000000,
  },
  {
    p: "500800000027000030180970400000526000300000008200003000700000600001000004900200001",
    s: "596834712427651839183972456879526143364719528215483967732148695651397284948265371",
    d: 58000000,
  },
  {
    p: "506041237001203406342576809008700043620004178437000900003010084009457301004000090",
    s: "596841237781293456342576819918762543625934178437185962253619784869457321174328695",
    d: 58000000,
  },
  {
    p: "507600000200480000830009000000500090040000008000078020780002000001000007300000050",
    s: "597613284216487935834259716178524693942136578653978421785362149421895367369741852",
    d: 58000000,
  },
  {
    p: "008600000000548900000090007402005600009000030030010090107200400000801200000000000",
    s: "598627341371548926624193857412935678759486132836712594167259483943871265285364719",
    d: 58000000,
  },
  {
    p: "002000003000040090004180500000957060000400050090000002060000315000610000050000007",
    s: "612579483587346291934182576321957864876423159495861732268794315743615928159238647",
    d: 58000000,
  },
  {
    p: "005024009000071000700000004300900005000040800080102000800093500036000000000000620",
    s: "615324789498571362723869154371986245269745831584132976842693517136257498957418623",
    d: 58000000,
  },
  {
    p: "600070090000286000007000003006003400100800050040050008000000007093000000800010500",
    s: "618374295935286174427195683586723419172849356349651728251438967793562841864917532",
    d: 58000000,
  },
  {
    p: "600700030040009000052630000000370600004000008000200005060018020000000000801000040",
    s: "618742539347859162952631487289375614534196278176284395765418923423967851891523746",
    d: 58000000,
  },
  {
    p: "000045070508000003070010094005000010007600800080403000000900400060000009000020000",
    s: "619345278548279163273816594495782316327691845186453927751968432862134759934527681",
    d: 58000000,
  },
  {
    p: "600070000308000000000104900050090420083000700006000090000802000005400273000000500",
    s: "619573842348629157572184936157396428983245761426718395734852619895461273261937584",
    d: 58000000,
  },
  {
    p: "600000040000000003870090060010760000005300000000200090004000320006078000000000100",
    s: "621837549459612873873594261912765438745389612368241795184956327236178954597423186",
    d: 58000000,
  },
  {
    p: "003000001950006000000250060000003070060000004400090000000000008500000920007014006",
    s: "623487591958136742174259863815643279769825134432791685396572418541368927287914356",
    d: 58000000,
  },
  {
    p: "600003000700000401000804902500300000080000007040020000000009005805001006002007100",
    s: "624913578798652431153874962517398624289146357346725819431269785875431296962587143",
    d: 58000000,
  },
  {
    p: "600004309000005080000010000070050043001000070009001000503000004080000750002080000",
    s: "625874319134695287897312465278956143351428976469731528513267894986143752742589631",
    d: 58000000,
  },
  {
    p: "000090405981004060000700000560070004000002000090360080009000000400000000200003706",
    s: "627198435981534267345726198562879314813452679794361582179645823436287951258913746",
    d: 58000000,
  },
  {
    p: "020003900040000735000001000000870100016300000003000008074000090900000840000000502",
    s: "627583914148269735539741286492876153816325479753914628274658391965132847381497562",
    d: 58000000,
  },
  {
    p: "000000013700680900005007000000104060000890350000000000960002000300900000580040000",
    s: "628459713743681925195327846859134267271896354436275189967512438314968572582743691",
    d: 58000000,
  },
  {
    p: "008000004009604000000800700005000000000100002000308659860900100017000000000002003",
    s: "628537914179624538453891726735269481986145372241378659862953147317486295594712863",
    d: 58000000,
  },
  {
    p: "020005000000100004050360000036050400009020080400000000000000001200008009003904006",
    s: "628745913397182564154369728736851492519423687482697135945236871261578349873914256",
    d: 58000000,
  },
  {
    p: "020500001400000000000601500076000030340008090000450000100040900000800360030000000",
    s: "629534871415987623783621549576192438341768295892453716167345982254819367938276154",
    d: 58000000,
  },
  {
    p: "000500003000290000080000006006080020030400850010000700900000002160004000000025000",
    s: "629578143341296587785143296596781324237469851814352769958617432162834975473925618",
    d: 58000000,
  },
  {
    p: "000750300000000900007010020000000000005000201008600004306029000070006400090400800",
    s: "629754318153268947487913526734182659965347281218695734346829175871536492592471863",
    d: 58000000,
  },
  {
    p: "000800007150620000000100000002070030080006000500000742000500000000000064090014503",
    s: "629853417154627398738149625912475836487236951563981742341568279875392164296714583",
    d: 58000000,
  },
  {
    p: "630009000200010005000040003007090000000000084008006050806000200000920100003004000",
    s: "631589427274613895589247613457892361362751984198436752816375249745928136923164578",
    d: 58000000,
  },
  {
    p: "002000050407310002000050030000009000000000460009760000060040005003900001200000070",
    s: "632497158457318692918652734146539827375821469829764513761243985583976241294185376",
    d: 58000000,
  },
  {
    p: "600509000000030004005000637090000805800020000050800000007300000240000000006010040",
    s: "634579128178236954925481637792143865863925471451867392517394286249658713386712549",
    d: 58000000,
  },
  {
    p: "030027500080000040100000002900400086000600310000000000000040037800000900053000100",
    s: "634827591582916743179354862915473286748692315326185479291548637867231954453769128",
    d: 58000000,
  },
  {
    p: "000800520000001000090005804000000062580400000041070300009000006700030090002900000",
    s: "634897521825341679197265834973518462586423917241679358359782146768134295412956783",
    d: 58000000,
  },
  {
    p: "030001000020000600000900000001000360000805019000007000900070125507080000006003007",
    s: "635721894829354671174968253751249368462835719398617542983476125547182936216593487",
    d: 58000000,
  },
  {
    p: "600018000008000000000205010000090040060001090000004002420000058900060000003000700",
    s: "635918274218647935749235816572896143864321597391754682426179358987563421153482769",
    d: 58000000,
  },
  {
    p: "037000005090000600800600000400905000970060002000002401000000000005200040000409306",
    s: "637148925194527683852693174423915867971864532586732491749356218365281749218479356",
    d: 58000000,
  },
  {
    p: "037000900180005000000060000300006040000090028200300005003980000012040800000000070",
    s: "637824951189735462425169783398256147576491328241378695763982514912547836854613279",
    d: 58000000,
  },
  {
    p: "000000052000080094070600000100094003200001000007000000301007000000060500906040030",
    s: "638419752512783694479625381165894273243571968897236145381957426724368519956142837",
    d: 58000000,
  },
  {
    p: "009000040000763000700000601090000800007508000020000000000000100160020005000409020",
    s: "639185247241763958785942631596274813317598462428631579972356184164827395853419726",
    d: 58000000,
  },
  {
    p: "600900080001043000000000590400000005930410000000530070060200000200000000070000048",
    s: "642975183591843627783162594417628935935417862826539471364281759258794316179356248",
    d: 58000000,
  },
  {
    p: "600250000285091000000830000000000300004186000710500600050000090000000031920000060",
    s: "643257189285691473197834256862749315534186927719523648356418792478962531921375864",
    d: 58000000,
  },
  {
    p: "005000001809020060000604009000000402002070600036010000000700080920005000100000200",
    s: "645987321879321564213654879781569432592473618436218957364792185928135746157846293",
    d: 58000000,
  },
  {
    p: "650000900300060420000009000010407800040000001070300009000100000500600010008050360",
    s: "651274983389561427427839156916427835243985671875316249762143598534698712198752364",
    d: 58000000,
  },
  {
    p: "001403000004000600000000050006000740087002000000030001000600009800070003190000000",
    s: "651483297234597618978216354316859742487162935529734861743625189865971423192348576",
    d: 58000000,
  },
  {
    p: "600000000002600005090050380000002030208000017046900000000000840504007000000080001",
    s: "653748192812639475497251386975812634238564917146973528761325849584197263329486751",
    d: 58000000,
  },
  {
    p: "000000000070000060901420000408090020000034580305800000590100300000000001000003850",
    s: "653789214274315968981426735468597123719234586325861497596148372837952641142673859",
    d: 58000000,
  },
  {
    p: "000008700108700000004006019006090080000080305002005000900000000300002694000050003",
    s: "653918742198724536274536819536297481749681325812345967927463158385172694461859273",
    d: 58000000,
  },
  {
    p: "600300007000470280080600050023000400408203001000000600000001000041080003090000000",
    s: "654328917139475286287619354723156498468293571915847632372561849541982763896734125",
    d: 58000000,
  },
  {
    p: "600001030000000504000500081960040300107000600405090000000002700002380000000900000",
    s: "654821937281739564379564281968147325137258649425693178896412753712385496543976812",
    d: 58000000,
  },
  {
    p: "600000800237400000009000203000190007006040050500000000000200010000603004003050600",
    s: "654932871237481596819567243382195467796348152541726938468279315925613784173854629",
    d: 58000000,
  },
  {
    p: "600010800000005010000090005092800004805000200070000050400006003010500000000007089",
    s: "657413892948265317231798645392851764865974231174632958489126573713589426526347189",
    d: 58000000,
  },
  {
    p: "658000000009000040000900006840000900010300720000050003005104030000000590700020000",
    s: "658243179179865342324917856843672915516398724297451683965184237482736591731529468",
    d: 58000000,
  },
  {
    p: "000000047403500006800020000000180060500000700200070103007000420000346000005000000",
    s: "659831247423597816871624359734189562518263794296475183367958421182346975945712638",
    d: 58000000,
  },
  {
    p: "070090025084600000200000000000020030460000809003100070920047006040510000000060000",
    s: "671893425384652791259471368817926534462735819593184672928347156746519283135268947",
    d: 58000000,
  },
  {
    p: "000000934000560000000000000060000070009002003002090850087000090100200700000053000",
    s: "675128934493567128218934567361845279859672413742391856587416392136289745924753681",
    d: 58000000,
  },
  {
    p: "000009000008030070400570000006100900700902001050000000900200008002068710000000300",
    s: "675829143298431576413576892326187954784952631159643287937215468542368719861794325",
    d: 58000000,
  },
  {
    p: "000905200030000089000008060307000000080100000090260050000000402000070600000809003",
    s: "678915234135642789924738165367584921582197346491263857819356472253471698746829513",
    d: 58000000,
  },
  {
    p: "600050400401000500000000069020800900000930001000702004800609000030000208040070000",
    s: "679153482481296537253487169324815976567934821198762354815629743736541298942378615",
    d: 58000000,
  },
  {
    p: "600010005000000090000690087067000001800700000200045900080020010046000030050000009",
    s: "679318425418572693325694187567239841894761352231845976783926514946157238152483769",
    d: 58000000,
  },
  {
    p: "000040900050100000400000570068000030005700006007050400000610008000000609200009000",
    s: "683547912752193864491268573168924735945731286327856491579612348814375629236489157",
    d: 58000000,
  },
  {
    p: "085100030000000000930002506204006100050008700000030000000000002000060005008400000",
    s: "685149237742653918931782546294576183356918724817234659173895462429361875568427391",
    d: 58000000,
  },
  {
    p: "000200405001030000000067109140300900000008500000004086000000600700080000060900004",
    s: "687219435921435768453867129148356972236798541579124386812543697794681253365972814",
    d: 58000000,
  },
  {
    p: "090050000800030051000080004070901000000000700002063000008200063010000070400000080",
    s: "691452837847639251325187694576941328934528716182763549758214963213896475469375182",
    d: 58000000,
  },
  {
    p: "090030000002400050000091000000005080103008005700310600400000010000080360060000070",
    s: "691532847382467951574891236946275183123648795758319624437926518215784369869153472",
    d: 58000000,
  },
  {
    p: "002000000103048009004300500000000004070001000320005060060070001000009402000800000",
    s: "692157843153648729784392516518726934476931258329485167965274381831569472247813695",
    d: 58000000,
  },
  {
    p: "002007480010020700000091002106000500050070600900000040720500000004060000000000900",
    s: "692357481318426795475891362146283579253974618987615243729548136534169827861732954",
    d: 58000000,
  },
  {
    p: "000040000080002005500000204030090006401000900000010003009070060000004070048000032",
    s: "692541387184732695573986214837495126461327958925618743259873461316254879748169532",
    d: 58000000,
  },
  {
    p: "003074000002000000700153020006000870050701003008000000060800001000006590000300600",
    s: "693274158512968734784153926146532879259781463378649215965827341837416592421395687",
    d: 58000000,
  },
  {
    p: "000000005702900004000306027000005000308240009010009000004807000000000000179000030",
    s: "693472815752918364841356927927685143368241759415739286234867591586193472179524638",
    d: 58000000,
  },
  {
    p: "000004000000006023051007090000080000006071050040050107830000001070260005000000030",
    s: "693524718487196523251837496715689342326471859948352167832945671174263985569718234",
    d: 58000000,
  },
  {
    p: "090000100004600000000040670000500000009006508020030000370000860100200000060050310",
    s: "693782145754691283281345679817529436439176528526438791375914862148263957962857314",
    d: 58000000,
  },
  {
    p: "000000401008002070070000008300020090000013000000000804056009000030007006004608000",
    s: "693785421148362579572491368365824197487913652219576834756149283831257946924638715",
    d: 58000000,
  },
  {
    p: "004000005000063000030001060180400000000070900400300000007008009006000230052000000",
    s: "694287315721563894538941762185492673263875941479316528317628459846159237952734186",
    d: 58000000,
  },
  {
    p: "600070000008090430200000079030500004900000006000008000802000061000200700000400090",
    s: "694375128718692435253814679136527984987143256425968317842739561569281743371456892",
    d: 58000000,
  },
  {
    p: "004005000000069075000020900028000000400200800100000064047000052000003000069800000",
    s: "694785123281369475735124986928641537456237819173598264847916352512473698369852741",
    d: 58000000,
  },
  {
    p: "605000000000007050017003406000980070000000620000060003020700000309050001060400000",
    s: "695248317843617952217593486436982175981375624752164893124739568379856241568421739",
    d: 58000000,
  },
  {
    p: "000000104200360070030901800058030200076800000000105000802000010000000060709000003",
    s: "695287134281364579437951826158639247976842351324175698862493715543718962719526483",
    d: 58000000,
  },
  {
    p: "000000743403005800100000000006580000904000100000020090560004009002100600000008000",
    s: "695812743473965812128347965216589437954736128837421596561274389782193654349658271",
    d: 58000000,
  },
  {
    p: "000025300005000009130000600700054800000800000060070090001000002509401006400000000",
    s: "697125384245368179138749625712954863953816247864273591381697452529481736476532918",
    d: 58000000,
  },
  {
    p: "090030400000400280000000060000350604061020050040008000000000000700260100210007005",
    s: "698532471537416289124789563872351694361924857945678312483195726759263148216847935",
    d: 58000000,
  },
  {
    p: "000043000004009000800000150260090530000030026503700400000021300000000700100000045",
    s: "712543689654819273839276154261498537947135826583762491475921368398654712126387945",
    d: 58000000,
  },
  {
    p: "000603000000109007058007006207000000340006000086000400000000208070010500100500009",
    s: "712683945463159827958247136297435681341896752586721493635974218879312564124568379",
    d: 58000000,
  },
  {
    p: "003005064000079530000000070050093000000000120004500700009000800000000002002416000",
    s: "713825964428679531965134278157293486396748125284561793649352817531987642872416359",
    d: 58000000,
  },
  {
    p: "000800000400150300000700900601500000500030410380000000020007000000000605007400800",
    s: "713829564498156327256743981641578293579632418382914756825367149934281675167495832",
    d: 58000000,
  },
  {
    p: "700009008203600500000400000000000067090000000000700104001270350800030000002000400",
    s: "714359628283617549569482713125943867497861235638725194941278356856134972372596481",
    d: 58000000,
  },
  {
    p: "705000080000000000000081005060079008230604090090000000004000810006000500000206000",
    s: "715932684983465172642781935461379258238654791597128463324597816176843529859216347",
    d: 58000000,
  },
  {
    p: "700900400006010200000000090050040020608007003000000008020000300000068000004750000",
    s: "715982436986314257243675891351846729698127543472539618827491365539268174164753982",
    d: 58000000,
  },
  {
    p: "700000005020040000000607020094080007000050000030000100000304200001000080065800003",
    s: "716238945823549716459617328694182537172953864538476192987364251341725689265891473",
    d: 58000000,
  },
  {
    p: "700206400045300000000001000500000000000003701020700058000000036109000000400800027",
    s: "718256493945387612362941875573168249894523761621794358287415936139672584456839127",
    d: 58000000,
  },
  {
    p: "710000050008060047000009000000000800906074002203600000000300008060000070040017000",
    s: "719438256538162947624759183471923865986574312253681794197346528362895471845217639",
    d: 58000000,
  },
  {
    p: "709400000600001900040000000308000075070005082005200300000620703000000000400900060",
    s: "719482536682531947543796821328149675974365182165278394891624753236857419457913268",
    d: 58000000,
  },
  {
    p: "000006002005003000002070840100482000000000070000000023000300600070005000001090080",
    s: "719846532485213769362579841137482956256931478948657123594328617873165294621794385",
    d: 58000000,
  },
  {
    p: "720000000800001005000030002000103600000000590070048000600300000050000079901000040",
    s: "723596418869421735415837962294153687138762594576948123647389251352614879981275346",
    d: 58000000,
  },
  {
    p: "700068000030900700004200350090000047063000500000006000000502000002003000070400002",
    s: "725368419631954728984217356298135647463729581157846293319572864842693175576481932",
    d: 58000000,
  },
  {
    p: "000081000908000200000300500000100093000000000004700082000200700160000000090003004",
    s: "725481936938567241641329578876152493219834657354796182483215769167948325592673814",
    d: 58000000,
  },
  {
    p: "000000060003600007000020008080010300070000010006003702000050000817902000500001400",
    s: "728135964453698127691427538285719346379264815146583792934856271817942653562371489",
    d: 58000000,
  },
  {
    p: "001000902020000000800090007150000000000007053200003060000016700040008030000200004",
    s: "731564982925781346864392517153649278496827153278153469389416725542978631617235894",
    d: 58000000,
  },
  {
    p: "730400100006005000000190000000010700000809062020000350070080040060000000000700520",
    s: "732468195916325874584197236643512789157839462829674351275981643468253917391746528",
    d: 58000000,
  },
  {
    p: "700000006000030007001028030000001000960000504000000090010050000000109040092006070",
    s: "734915826829634157651728439275491683963287514148563792417352968386179245592846371",
    d: 58000000,
  },
  {
    p: "700000004000040390000308015004590100300060000006804000002000700070000050600050030",
    s: "735916824168245397429378615284597163357162489916834572592683741873421956641759238",
    d: 58000000,
  },
  {
    p: "000080406004000070208000035090030000653070000000600008302590007006400000070000000",
    s: "735982416964153872218746935891235764653874129427619358342591687186427593579368241",
    d: 58000000,
  },
  {
    p: "000020100005009000000007500180000000067380009300014007000200003000040060010700040",
    s: "736528194425169378891437526184972635267385419359614287648291753572843961913756842",
    d: 58000000,
  },
  {
    p: "030000020000830000450010300007100560320050070100080000060000004000001000074000006",
    s: "738549621612837495459612387847123569326954178195786243561278934983461752274395816",
    d: 58000000,
  },
  {
    p: "008001009000070143000000000423000000100806200000500000200000060006000790000409000",
    s: "738641529562978143914352687423197856159836274687524931291783465346215798875469312",
    d: 58000000,
  },
  {
    p: "000450000040310900008700200500001000092570000000230080000000053920000000301000000",
    s: "739452618246318975158769234563891427892574361417236589684927153925183746371645892",
    d: 58000000,
  },
  {
    p: "001300000600070001000000089407100003006005008300400200010000507900020000000900000",
    s: "741389625689572341532614789427168953196235478358497216213846597965721834874953162",
    d: 58000000,
  },
  {
    p: "001608000000000000290000680070094006030870050004000000000065400008003000103000500",
    s: "741658923386912745295347681872594316639871254514236897927165438458723169163489572",
    d: 58000000,
  },
  {
    p: "700000600036000008080000050020901080079043000000700006400009000000308004200170900",
    s: "742815639536297148981436752624951387879643215315782496463529871197368524258174963",
    d: 58000000,
  },
  {
    p: "000090580030010070000006300070020006900080000600000004000002000400000150008130000",
    s: "746293581839415672251876349175324896924681735683957214317542968492768153568139427",
    d: 58000000,
  },
  {
    p: "006059003900100008005000000008007000100000020020000070000020790600308000004000005",
    s: "746859213932176458815432967468217539173985624529643871381524796657398142294761385",
    d: 58000000,
  },
  {
    p: "049000000500000001103000600000000000000350080001409002016007500000004390080060000",
    s: "749621835568743921123598674895172463472356189631489752916237548257814396384965217",
    d: 58000000,
  },
  {
    p: "703900000240000039000000208000030001036700800902000006005170600000000000009350000",
    s: "753928164248617539691543278584236791136795842972481356425179683317864925869352417",
    d: 58000000,
  },
  {
    p: "000090000300050068000002000080040201030009080070028030010000005067500000005000604",
    s: "756893142342751968198462357689345271234179586571628439413286795967514823825937614",
    d: 58000000,
  },
  {
    p: "050130000100040000000800500200000080300080090001700000002060901690003004007000060",
    s: "758136429126945738943872516269354187374681295581729643832467951695213874417598362",
    d: 58000000,
  },
  {
    p: "700020104060050000400800050600900000000000790280000000026004001000080000900017600",
    s: "758329164362451987491876253617942835543168792289735416826594371174683529935217648",
    d: 58000000,
  },
  {
    p: "000000300000075060400021005006580000079000250004000100080700000900040010000030987",
    s: "758964321192375864463821795216587439879413256534296178381759642927648513645132987",
    d: 58000000,
  },
  {
    p: "000040030000000900030600807200970000000005400047002006006000350002000000905001000",
    s: "759248631628713945134659827261974583893165472547382196416827359382596714975431268",
    d: 58000000,
  },
  {
    p: "000000005200430600000000892006501000005008040000003900800094000000000300027000000",
    s: "761289435298435617534167892986541723375928146142673958853794261619852374427316589",
    d: 58000000,
  },
  {
    p: "060500019000007000000430008035100090004009000000000056100083000300700800040000060",
    s: "763528419481697532592431678835176294624359187917842356176283945359764821248915763",
    d: 58000000,
  },
  {
    p: "003904000000800000020370004001008200600030000900002008106500030000000007000006045",
    s: "763924581419865723825371694351498276682137459947652318176549832594283167238716945",
    d: 58000000,
  },
  {
    p: "000920050000005038100030700090400000030070090540800003405000006000000007602000000",
    s: "763928451924715638158634729891463572236571894547892163475289316389156247612347985",
    d: 58000000,
  },
  {
    p: "060100020320054000040030700000800500000540000000003087006080204000900600090020008",
    s: "765198423329754816841632759237869541918547362654213987176385294482971635593426178",
    d: 58000000,
  },
  {
    p: "060000008400090027800035100008000605070100000000200010006000000950004030002000001",
    s: "765421398431698527829735164218943675573186942694257813186372459957814236342569781",
    d: 58000000,
  },
  {
    p: "000000002182000300040500170600030000023104500018000000030000280000350600001008090",
    s: "765813942182479356349526178674935821923184567518267439436791285897352614251648793",
    d: 58000000,
  },
  {
    p: "060903400100050003003710090007500604029060000000000000000200005000000740000170980",
    s: "765923418198456273243718596817592634429361857356847129971284365582639741634175982",
    d: 58000000,
  },
  {
    p: "060000082200080050000009000400070103002400000900000020000063000000800001108040900",
    s: "769514382241386759853729614485972163632451897917638425594163278326897541178245936",
    d: 58000000,
  },
  {
    p: "700001040009020010000009005907008130060000000000300700000187000050000000400000308",
    s: "782651943549823617136479825927548136365712489814396752293187564658934271471265398",
    d: 58000000,
  },
  {
    p: "080050600000600007006307200900000350000001002040005010500000003078400000400000080",
    s: "783254691294618537156397248917826354835941762642735819569182473378469125421573986",
    d: 58000000,
  },
  {
    p: "780000000000000079090053000031006000007000000500000380020005006000694100050008400",
    s: "785169243613842579492753618231986754847531962569427381124375896378694125956218437",
    d: 58000000,
  },
  {
    p: "000403001502700000030000400015000300000000059900080070008900000090020004600000008",
    s: "786493521542718963139652487815279346274136859963584172428961735397825614651347298",
    d: 58000000,
  },
  {
    p: "000032500000400200001700000600007003902000006000000004070024090810000000090005030",
    s: "789632541563419287421758369658247913942381756137596824376824195815963472294175638",
    d: 58000000,
  },
  {
    p: "001000058050060100000000009104300806600800000009000020270010000000003000008040300",
    s: "791432658352968147846751239124395876637824915589176423273619584465283791918547362",
    d: 58000000,
  },
  {
    p: "000150000000200790003090000605008901300000600000500800108070020000020007004006000",
    s: "792154368561283794843697215625738941387941652419562873158379426936425187274816539",
    d: 58000000,
  },
  {
    p: "000060000030200980001005000270009050050630800004000000900000000400000600006027040",
    s: "792861435635274981841395762278149356159632874364758219913486527427513698586927143",
    d: 58000000,
  },
  {
    p: "005060020200000000060080010800400070037000000000000500078092000000050900900030400",
    s: "795163824281547639364289715819425376537916248642378591478692153123854967956731482",
    d: 58000000,
  },
  {
    p: "000030000438005100200900000080010403000000051020040800000300708960000000002160500",
    s: "795431682438625197216978345589716423647283951321549876154392768963857214872164539",
    d: 58000000,
  },
  {
    p: "000430010200000509800600000104300205030040000070500008000000600000050093008000400",
    s: "795432816246187539813695724184369275532748961679521348351974682427856193968213457",
    d: 58000000,
  },
  {
    p: "000000052400000009000009000150006070300100006000007200060020000009083010500040000",
    s: "798364152415278369623519847152836974374192586986457231861725493249683715537941628",
    d: 58000000,
  },
  {
    p: "790020600060000705001090030004108000300075000000900000100040300000000200026080001",
    s: "798523614263814795541796832974168523382475169615932478157249386839651247426387951",
    d: 58000000,
  },
  {
    p: "000000003500081000060000025903700060010068000000000240009430086000800070004000000",
    s: "798652413542381697361947825923714568415268739687593241279435186156829374834176952",
    d: 58000000,
  },
  {
    p: "800000000700002501005070280070500600400006030009004000020010000030000700050000006",
    s: "812459367796382541345671289273598614481726935569134872628917453134265798957843126",
    d: 58000000,
  },
  {
    p: "003007000000000932020400018000050097000600000400003580380200000005009000700000000",
    s: "813927654647581932529436718136852497958674321472193586384265179265719843791348265",
    d: 58000000,
  },
  {
    p: "004000000500608400070000280050004009000070800060051000083000000790200000000005001",
    s: "814527963529638417376149285257864139431972856968351724183496572795213648642785391",
    d: 58000000,
  },
  {
    p: "000004000006089003300000601000050000068000000000000402007090030130007090500806000",
    s: "815364927726189543349275681471952368268743159953618472687491235134527896592836714",
    d: 58000000,
  },
  {
    p: "810000600402000000000000503650000089020907000000010020070549000000068001080000005",
    s: "815793642432156897967824513651432789324987156798615324176549238543268971289371465",
    d: 58000000,
  },
  {
    p: "010500004000000002005030000360470000400000308100002090000100000002706010000000060",
    s: "816527934934861752275934681368479125429615378157382496693158247542796813781243569",
    d: 58000000,
  },
  {
    p: "000000042400080061000001080005010020000098017103006004020000000730600000009050000",
    s: "816975342457283961392461785985714623264398517173526894521839476738642159649157238",
    d: 58000000,
  },
  {
    p: "000500420400170000000000051906007040300040100700000000002035000000060800089000300",
    s: "817593426465172983293486751926317548358249167741658239172835694534961872689724315",
    d: 58000000,
  },
  {
    p: "000050003400300000000004070500730002740680000006005000080060900001000020960200100",
    s: "817956243459372816623814579598731462742689351136425798284167935371598624965243187",
    d: 58000000,
  },
  {
    p: "000070306360400820500000090000000001000807400100003009000069000000000000004020570",
    s: "819275346367491825542386197478952631936817452125643789783569214251734968694128573",
    d: 58000000,
  },
  {
    p: "000007050020000000000004906056000002300900000000700100002650000703090400000008000",
    s: "819367254624519837537284916956841372371926548248735169482653791763192485195478623",
    d: 58000000,
  },
  {
    p: "000700600560008000000010902000800005180600004907020000070069000300000000490000200",
    s: "819742653562938417743516982624871395185693724937425861271369548356284179498157236",
    d: 58000000,
  },
];
